import { render, staticRenderFns } from "./roi.vue?vue&type=template&id=e1c0d96c&"
import script from "./roi.vue?vue&type=script&lang=js&"
export * from "./roi.vue?vue&type=script&lang=js&"
import style0 from "./roi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports